import { useState } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import styles from "./S1_ActivationStep1.module.scss";
import { useAppSelector } from "../../../../app/hooks";
import { IMEIFailureModal } from "./IMEIFailureModal";
import {
  TextFieldCust,
  LinearProgressBarCust,
  ButtonCust,
  ManageCard,
} from "../../../widgets";
import { gaCategory } from "../../../../Types/GoogleAnalytics";
import OneTimeCharge from "./OneTimeCharge";
import OneTimeChargeComp from "./OneTimeChargeComp";
import { AddShippingAddressDialog } from "../../Account/AddLinesDialog/AddShippingAddressDialog/AddShippingAddressDialog";
import { ChangeLinePreferenceDialog } from "../../../ChangeLinePreferenceDialog/ChangeLinePreferenceDialog";
import { SimTypes } from "../../../../features/checkout/Types";
import Config from "../../../../config/env.config.json";
import { BrandNameUpdate } from "../../../../utils/commonFunctions/BrandNameUpdate";
import mobileImage from "../../../../assets/Common/mobileImage.svg";
import flightlv from "../../../../assets/Common/flightlv.svg";
import { InternalBanner } from "../../../common";
import { AddShippingAddressDialogComp } from "../../Account/AddLinesDialog/AddShippingAddressDialog/AddShippingAddressDialogComp";

const T6ActivationStep1 = (props: any) => {
  const {
    handleStep,
    currentLine,
    numChangeHandler,
    content,
    simPrefenceContent,
    GAAndFBEventsHandler,
    kitBasePrice,
    sendSimOption,
    deviceComp,
    setDeviceComp,
    currentModal,
    setCurrentModal,
    formik,
    btnLoader,
    setBtnLoader,
    modalStatus,
    setModalStatus,
  } = props;
  const provideEdit: boolean = currentLine?.esim ? true : false;
  const onTimeActivation = localStorage.getItem("oneTimeactivation");
  const getLatestAdd: any = JSON?.parse(
    localStorage.getItem("latestAddress") || "null"
  );
  const [addressData, setAddressData] = useState<any>(() => getLatestAdd);
  const [simType, setSimType] = useState<SimTypes>(SimTypes.eSim);
  const [selectedCard, setSelectedCard] = useState<any>(null);
  const { getCCDetails } = useAppSelector((state: any) => state?.account || {});

  const {
    imei_view,
    Iemi_con,
    imei_form,
    sp1_title,
    step_txt,
    msgs,
    verfiy_details_txt,
  } = content || {};

  const changeModal = (val?: string) => {
    setCurrentModal(val ?? "");
  };
  const closeOneTimeCharge = () => {
    changeModal();
    setAddressData(null);
    localStorage.removeItem("latestAddress");
    onTimeActivation && localStorage.removeItem("oneTimeactivation");
    localStorage.removeItem("oneTimeChargeDeliveryType");
  };
  const showCardChangeModalHandler = () => {
    changeModal("oneTimeChrg");
  };
  const ProceedPayment = () => {};
  const changeCard = (obj?: any) => {
    if (obj) {
      localStorage.setItem("latestAddress", JSON.stringify(obj));
      setAddressData(obj);
    }
    changeModal("cardsModal");
  };
  const changeAddress = (obj?: any) => {
    obj && setAddressData(obj);
    changeModal("addressDetails");
  };
  const handleNavigateNext = (type: any) => {
    changeModal(type);
  };
  const SaveAddress = (e: any) => {
    changeModal("oneTimeChrg");
    e?.billingAddress && setAddressData(e.billingAddress);
  };
  const chooseModalResult = () => {
    if (simType === SimTypes.sim) {
      changeModal("oneTimeChrg");
    } else {
      handleStep(true);
      changeModal();
    }
    setSimType(SimTypes.eSim);
  };
  //   <ArrowBackIcon
  //   sx={{ ml: { md: "30px", sm: "25px", xs: "4%" } }}
  //   className={styles.arrow_icon}
  //   onClick={() => handleStep(false)}
  // />

  return (
    <>
      {/* <InternalBanner
        // key={key}
        pageName={"Activation"}
        apiEndPoint={"myAccBanner"}
        type={"internal"}
      /> */}
      <Box
        sx={{
          cursor: "pointer",
          width: "18px",
          height: "18px",
          zIndex: "100",
          left: "0",
          position: "absolute",
          ml: { md: "30px", sm: "25px", xs: "25px" },
          mt: { md: "60px" },
          display: { xs: "none", sm: "inline-block" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "18px",
            height: "18px",
            position: "absolute",
            left: "3rem",
          }}
          onClick={() => handleStep(false)}
        >
          <ArrowBackIosIcon sx={{ width: "18px" }} />
          <Box>Back</Box>
        </Box>
      </Box>
      {currentModal !== "oneTimeChrg" && currentModal !== "addressDetails" && (
        <>
          <Box className={styles.step1_main}>
            {/* <Box className={styles.heading_container}>
        <ArrowBackIcon
          sx={{ ml: { md: "30px", sm: "25px", xs: "4%" } }}
          className={styles.arrow_icon}
          onClick={() => handleStep(false)}
        />
        <Typography className={styles.title_main}>{sp1_title}</Typography>
      </Box>
      <Box className={styles.stepper_content}>
        <Typography className={styles.stepper_txt}>{step_txt}</Typography>
        <Box width={{ xs: "90%", sm: "50%", md: "35%" }} mb="25px">
          <LinearProgressBarCust value={25} variant={"determinate"} />
        </Box>
      </Box> */}
            {!deviceComp ? (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    background: "var(--lightgrey_3)",
                  }}
                >
                  <Paper
                    sx={{
                      // border: "1px solid rgba(0,0,0,.2)",
                      width: { xs: "94%", sm: "724px" },
                      // height: "600px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      mt: { xs: "60px" },
                      boxShadow: { xs: "unset !important" },
                      marginBottom: "45px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        py: { xs: "31px" },
                      }}
                    >
                      <Box
                        component="img"
                        alt={"circular_loader"}
                        src={content?.imei_comp_headIcon?.data?.attributes?.url}
                        sx={{ width: { xs: "33px", paddingRight: "16px" } }}
                      />
                      <Typography
                        sx={{
                          fontSize: "24px",
                          fontFamily: "var(--font_family_Bold)",
                        }}
                      >
                        {sp1_title}
                      </Typography>
                    </Box>
                    <hr
                      style={{ border: "1px solid #F8F8F8", width: "100%" }}
                    ></hr>
                    <Box sx={{ textAlign: "center" }}>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontFamily: "var(--font_family_Medium)",
                          mt: { xs: "18px" },
                          mb: { xs: "21px" },
                        }}
                      >
                        {BrandNameUpdate(imei_form?.desc)}
                      </Typography>
                    </Box>
                    <Box
                      width={{ xs: "80%", sm: "80%", md: "50%" }}
                      sx={{ px: { md: "12px" } }}
                    >
                      <TextFieldCust
                        value={formik.values.imei}
                        name="imei"
                        onChange={(e: any) => numChangeHandler(e, formik)}
                        onBlur={formik.handleBlur}
                        type={"text"}
                        label={imei_form?.txt_ph}
                        maxLength={15}
                        error={formik.errors?.imei ? true : false}
                        helperText={formik.errors?.imei}
                        onKeyUp={(e: any) => {
                          if (e.key === "Enter") {
                            formik.handleSubmit();
                          }
                        }}
                      />
                      <Box display="flex" justifyContent="end">
                        <Typography className={styles.activation_limit_div}>
                          {formik.values.imei.length}/15
                        </Typography>
                      </Box>
                    </Box>
                    {/* <Box display="flex" justifyContent="end">
        <Typography sx={{fontSize:"8px", fontFamily:"var(--font_family_Regular)"}}>
           {formik.values?.phoneNumber?.length}/10
        </Typography>
        </Box> */}
                    <Box component="p">{imei_form?.note}</Box>
                    <Box sx={{ marginBottom: "20px" }}>
                      <ButtonCust
                        variantType={Config.PRIMARY_BUTTON_TYPE}
                        sx={{
                          width: { xs: "250px", sm: "250px", md: "250px" },
                          height: { md: "50px !important" },
                        }}
                        disabled={
                          formik.values?.imei.length === 0
                            ? true
                            : !formik?.isValid
                        }
                        onClick={() => formik.handleSubmit()}
                        loading={btnLoader}
                      >
                        {imei_form?.check_btn}
                      </ButtonCust>
                    </Box>
                  </Paper>
                </Box>
                <Box
                  className={styles.activation_bottom}
                  sx={{ background: "var(--lightgrey_3)" }}
                >
                  <Box>
                    <Typography
                      className={styles.activation_bottom_text1}
                      sx={{
                        mb: "5px",
                        fontFamily: " var(--font_family_Semibold)",
                      }}
                    >
                      {Iemi_con?.title}
                    </Typography>
                    <Typography
                      className={styles.activation_bottom_text1}
                      sx={{ fontFamily: " var(--font_family_Medium)" }}
                    >
                      {Iemi_con?.desc}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      margin: "20px 0 50px 0",
                    }}
                    width={{ xs: "90%", sm: "fit-content" }}
                  >
                    {Iemi_con?.iemiContent.map((data: any) => {
                      return (
                        <Box
                          className={styles.activation_version_container}
                          mt={"20px"}
                          key={data.desc1}
                        >
                          <img
                            width={23}
                            height={23}
                            className={styles.os_img}
                            src={data.img?.data?.attributes?.url}
                            alt={data.img?.data?.attributes?.alternativeText}
                          />
                          <Box>
                            <Typography className={styles.os_text_1}>
                              {data.desc1}
                            </Typography>
                            <Typography className={styles.os_text_2}>
                              {data.desc2}
                            </Typography>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              </>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  background: "var(--lightgrey_3)",
                  height: "fit-content",
                  minHeight: "88vh",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Paper
                  sx={{
                    // border: "1px solid rgba(0,0,0,.2)",
                    width: { sm: "801px" },
                    height: { xs: "100%", md: "400px" },
                    mt: { xs: "60px" },
                    boxShadow: { xs: "unset !important" },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      py: { xs: "31px" },
                    }}
                  >
                    <Box
                      component="img"
                      alt={"circular_loader"}
                      src={content?.mobile_icon_main?.data?.attributes?.url}
                      sx={{ width: { xs: "20px", paddingRight: "34px" } }}
                    />
                    <Typography
                      sx={{
                        fontSize: "24px",
                        fontFamily: "var(--font_family_Bold)",
                      }}
                    >
                      {verfiy_details_txt}
                    </Typography>
                  </Box>
                  <hr style={{ border: "1px solid #F8F8F8" }}></hr>
                  <Box sx={{ textAlign: "center" }}>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontFamily: "var(--font_family_Medium)",
                        mt: { xs: "18px" },
                        mb: { xs: "21px" },
                      }}
                    >
                      {step_txt}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                      justifyContent: "center",
                      mx: "68px",
                      gap: { xs: "20px", md: 0 },
                    }}
                  >
                    <Box sx={{ display: { xs: "flex" } }}>
                      <Box
                        component="img"
                        alt={"circular_loader"}
                        src={content?.mobile_icon_imei?.data?.attributes?.url}
                        sx={{ width: { xs: "20px" }, mr: "20px" }}
                      />
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="baseline"
                        sx={{
                          mr: "70px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontFamily: "var(--font_family_Medium)",
                            color: "var(--text_color)",
                          }}
                        >
                          {imei_view?.deviceID}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontFamily: "var(--font_family_Semibold)",
                          }}
                        >
                          {currentLine?.imei}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ display: { xs: "flex" } }}>
                      <Box
                        component="img"
                        alt={"circular_loader"}
                        src={content?.mobile_icon_device?.data?.attributes?.url}
                        sx={{ width: { xs: "20px" }, mr: "20px" }}
                      />
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="baseline"
                        sx={{ mr: "70px" }}
                      >
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontFamily: "var(--font_family_Medium)",
                            color: "var(--text_color)",
                          }}
                        >
                          {imei_view?.device}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontFamily: "var(--font_family_Semibold)",
                          }}
                        >
                          {currentLine?.model}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ display: { xs: "flex" } }}>
                      <Box
                        component="img"
                        alt={"circular_loader"}
                        src={
                          content?.mobile_icon_simtype?.data?.attributes?.url
                        }
                        sx={{ width: { xs: "20px" }, mr: "20px" }}
                      />
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="baseline"
                      >
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontFamily: "var(--font_family_Medium)",
                            color: "var(--text_color)",
                          }}
                        >
                          {imei_view?.imei_id}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontFamily: "var(--font_family_Semibold)",
                          }}
                        >
                          {currentLine?.esim
                            ? content?.esim_txt
                            : content?.psim_txt}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{ textAlign: "center", mt: "25px", mb: "36px" }}>
                    <ButtonCust
                      variantType={Config.PRIMARY_BUTTON_TYPE}
                      onClick={() => {
                        handleStep(true),
                          GAAndFBEventsHandler(
                            gaCategory.activation,
                            imei_view?.nxt_btn
                          );
                      }}
                      sx={{
                        width: { xs: "250px", sm: "250px", md: "250px" },
                        height: { md: "50px !important" },
                      }}
                    >
                      {imei_view?.nxt_btn}
                    </ButtonCust>
                  </Box>
                  <Box
                    onClick={() => {
                      setDeviceComp(false);
                      GAAndFBEventsHandler(
                        gaCategory.activation,
                        imei_view?.edd_txt
                      );
                    }}
                  >
                    <Typography
                      sx={{
                        textAlign: "center",
                        color: "var(--primary_color)",
                        fontSize: "16px",
                        fontFamily: "var(--font_family_semiBold)",
                        cursor: "pointer",
                        mb: "2rem",
                      }}
                    >
                      {content?.edit_phone_txt}
                    </Typography>
                  </Box>
                  {/* <Box>
            <Box component="span">
              Note:
            </Box>
          </Box> */}
                </Paper>
                <Box
                  display="flex"
                  justifyContent="center"
                  sx={{ m: "30px auto 30px auto" }}
                  width="46%"
                  alignItems={"baseline"}
                >
                  <Box component="span">{content?.Note_txt}&nbsp;</Box>
                  <Box component="p" textAlign={"center"}>
                    <Box
                      component="span"
                      sx={{
                        fontFamily: "var(--font_family_Regular)",
                        fontSize: "16px",
                      }}
                    >
                      {content?.note_desc}&nbsp;
                    </Box>
                    <Box
                      component="a"
                      sx={{
                        color: "var(--primary_color)",
                        cursor: "pointer",
                        textDecoration: "none",
                      }}
                      href={content?.psim_clickhere_link}
                      target="_blank"
                    >
                      {content?.click_here_txt}
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
            {modalStatus && (
              <IMEIFailureModal
                modalFg={modalStatus}
                closeHandler={() => setModalStatus(false)}
                content={content}
              />
            )}
            {currentModal === "cardsModal" && (
              <ManageCard
                cardData={getCCDetails}
                showCardChangeModal={true}
                setShowCardChangeModal={showCardChangeModalHandler}
                isModalRequired={true}
                pageName={"activation"}
                isDescription={false}
                payType={false}
                ProceedPayment={ProceedPayment}
                isPayConfirm={true}
                setSelectedCard={setSelectedCard}
                activationOptional={true}
              />
            )}

            {currentModal === "chooseType" && (
              <ChangeLinePreferenceDialog
                open={true}
                onClose={closeOneTimeCharge}
                content={simPrefenceContent}
                onConfirm={chooseModalResult}
                simType={simType}
                setSimType={setSimType}
                pageName={"activation"}
                simCost={
                  kitBasePrice +
                  (currentLine?.selectedShippingMethod?.shippingAmount || 0)
                }
              />
            )}
          </Box>
        </>
      )}
      {currentModal === "oneTimeChrg" && (
        <OneTimeChargeComp
          //   onClose={closeOneTimeCharge}
          changeCard={changeCard}
          changeAddress={changeAddress}
          latestAddress={addressData}
          loaderHandler={setBtnLoader}
          btnLoader={btnLoader}
          currentLine={currentLine}
          content={content}
          sendSimOptions={sendSimOption}
          kitBasePrice={kitBasePrice}
          handleNavigateNext={handleNavigateNext}
        />
      )}
      {currentModal === "addressDetails" && (
        <AddShippingAddressDialogComp
          open={true}
          onClose={SaveAddress}
          content={content}
          updateAddress={(e: any) => {
            SaveAddress(e);
          }}
          pageName="activation"
        />
      )}
    </>
  );
};
export default T6ActivationStep1;
